/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Academic_Title_PlaceholderInputs */

const en_candidate_profile_academic_title_placeholder = /** @type {(inputs: Candidate_Profile_Academic_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., B.Sc., M.Sc.`)
};

const de_candidate_profile_academic_title_placeholder = /** @type {(inputs: Candidate_Profile_Academic_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. B.Sc., M.Sc.`)
};

/**
* | output |
* | --- |
* | "e.g., B.Sc., M.Sc." |
*
* @param {Candidate_Profile_Academic_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_academic_title_placeholder = /** @type {((inputs?: Candidate_Profile_Academic_Title_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Academic_Title_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_academic_title_placeholder(inputs)
	return en_candidate_profile_academic_title_placeholder(inputs)
});